import React, { useEffect, useState } from "react";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { useLanguage } from "../Translations/LenguageContext";
import { useNavigate, useParams } from "react-router-dom";
import DeleteItemModal from "../Components/DeleteItemModal";
import MainGeoLoader from "../Loaders/MainGeoLoader";
import SettingsPropertyModal from "./SettingsPropertyModal";
import PropInstallation from "./PropSetup/PropInstallation";
import PropOverview from "./PropOverview";
import MainPropLoader from "../Loaders/MainPropLoader";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const OpenProperty = ({
    account_id,
    userData,
    singleOrgData,
    loadingSingleOrg,
    fetchSingleOrganization
}) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { org_id, property_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [openSettingsModal, setOpenSettingsModal] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [sortOrder, setSortOrder] = useState("asc");
    const [searchTerm, setSearchTerm] = useState("");
    const [verifyContent, setVerifyContent] = useState({})
    const [loadingVerify, setLoadingVerify] = useState(false);
    const [errorMessageVerify, setErrorMessageVerify] = useState({ message: "", display: false });
    const [showVerifyDomain, setShowVerifyDomain] = useState(false)
    const [openInfoInstallationModal, setOpenInfoInstallationModal] = useState(false)


    const [propData, setPropData] = useState({
        id: "",
        name: "",
        domain: "",
        base_url: "",
        site_id: "",
        status: "",
        verification_status: "",
        verified_at: "",
        tag_status: "",
        last_tag_seen_at: "",
        deployment_enabled: "",
        created_at: "",
        updated_at: "",
    });

    const fetchData = async () => {
        setLoading(true);

        try {
            const response = await fetch(
                `${GEN_BACKEND_LINK}/get_property`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        account_id,
                        org_id,
                        property_id
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setData(result.data);

            setPropData({
                id: result?.data?.id,
                name: result?.data?.name,
                domain: result?.data?.domain,
                base_url: result?.data?.base_url,
                site_id: result?.data?.site_id,
                status: result?.data?.status,
                verification_status: result?.data?.verification_status,
                verified_at: result?.data?.verified_at,
                tag_status: result?.data?.tag_status,
                last_tag_seen_at: result?.data?.last_tag_seen_at,
                deployment_enabled: result?.data?.deployment_enabled,
                created_at: result?.data?.created_at,
                updated_at: result?.data?.updated_at,

                domain_record_name: result?.data?.domain_record_name,
                domain_record_key: result?.data?.domain_record_key,
            });
        } catch (err) {
            console.error("Error fetching property:", err);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    const handleVerifyDomain = async () => {
        setLoadingVerify(true);
        setErrorMessageVerify({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/verify_domain`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    property_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setVerifyContent({
                verified: data?.verified,
                verification_status: data?.verification_status,
                domain: data?.domain,
                message: data?.message,
            })


        } catch (error) {
            setErrorMessageVerify({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingVerify(false);
        }
    };


    const exit = () => {
        navigate(`/console/organizations/${org_id}/properties`);
    };

    useEffect(() => {
        if (account_id && org_id && property_id) {
            fetchData();
            handleVerifyDomain()
        }
    }, [account_id, org_id, property_id]);

    return (
        <div className="open_frame_cont">
            <div className="open_frame_cont_header">
                {loading ? (
                    <div className="open_frame_title_loading_cont">
                        <div className="open_frame_title_loading"></div>
                        <div className="open_frame_button_loading"></div>
                    </div>
                ) : (
                    <>
                        <div className="open_frame_title fade-in">
                            <button
                                className="open_frame_cont_header_btn_exit"
                                onClick={exit}
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                            </button>

                            {data?.name || property_id}
                        </div>
                        <button
                            className="open_frame_cont_header_btn fade-in"
                            onClick={() => setOpenSettingsModal(true)}
                        >
                            <HiOutlineDotsVertical />
                        </button>
                    </>
                )}

            </div>

            {loading ? (
                <MainPropLoader />
            ) : data?.tag_status == "NOT_INSTALLED" ? (
                <PropInstallation
                    account_id={account_id}
                    org_id={org_id}
                    property_id={property_id}
                    domain={data?.domain}
                    site_id={data?.site_id}
                    fetchData={fetchData}
                    errorMessage={errorMessage}
                    openInfoInstallationModal={openInfoInstallationModal}
                    setOpenInfoInstallationModal={setOpenInfoInstallationModal}
                />
            ) : (
                <PropOverview
                    data={data}
                    fetchData={fetchData}
                    handleVerifyDomain={handleVerifyDomain}
                    verifyContent={verifyContent}
                    loadingVerify={loadingVerify}
                    setLoadingVerify={setLoadingVerify}
                    errorMessageVerify={errorMessageVerify}
                    setErrorMessageVerify={setErrorMessageVerify}
                    showVerifyDomain={showVerifyDomain}
                    setShowVerifyDomain={setShowVerifyDomain}
                    setOpenSettingsModal={setOpenSettingsModal}
                    openInfoInstallationModal={openInfoInstallationModal}
                    setOpenInfoInstallationModal={setOpenInfoInstallationModal}
                />
            )}

            <SettingsPropertyModal
                account_id={account_id}
                show={openSettingsModal}
                handleClose={() => setOpenSettingsModal(false)}
                fetchRecords={fetchData}
                setPropData={setPropData}
                propData={propData}
                setOpenDelete={setOpenDelete}
            />

            <DeleteItemModal
                account_id={account_id}
                show={openDelete}
                handleClose={() => setOpenDelete(false)}
                fetchRecords={exit}
                item={data}
                endpoint={"delete_property"}
                title={t.properties.delete_title}
                description={t.properties.delete_desc}
                input_value={data}
            />
        </div>
    );
};

export default OpenProperty;